"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconCheck = _interopRequireDefault(require("@instructure/ui-icons/lib/Solid/IconCheck"));

var _IconArrowOpenEnd = _interopRequireDefault(require("@instructure/ui-icons/lib/Solid/IconArrowOpenEnd"));

var _keycode = _interopRequireDefault(require("keycode"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uid = _interopRequireDefault(require("@instructure/uid"));

var _uiPropTypes = require("@instructure/ui-prop-types");

var _deprecated = _interopRequireDefault(require("@instructure/ui-utils/lib/react/deprecated"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _getElementType = _interopRequireDefault(require("@instructure/ui-utils/lib/react/getElementType"));

var _createChainedFunction = _interopRequireDefault(require("@instructure/ui-utils/lib/createChainedFunction"));

var _isActiveElement = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/isActiveElement"));

var _findDOMNode = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/findDOMNode"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _MenuContextTypes = require("../../../utils/MenuContextTypes");

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _dec3, _class, _class2, _temp;

var styles = {
  componentId: 'sJGfW',
  template: function template(theme) {
    return "\n\n.sJGfW_bGBk{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;background:".concat(theme.background || 'inherit', ";border:none;border-radius:0;border-radius:initial;box-sizing:border-box;cursor:pointer;display:block;font-family:").concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";line-height:").concat(theme.lineHeight || 'inherit', ";margin:0;outline:none;padding:").concat(theme.padding || 'inherit', ";position:relative;text-align:start;transition:background 0.2s;user-select:none;width:100%}\n\n[dir=ltr] .sJGfW_bGBk{text-align:left}\n\n[dir=rtl] .sJGfW_bGBk{text-align:right}\n\n.sJGfW_bGBk.sJGfW_eyNH .sJGfW_dnnz{inset-inline-end:").concat(theme.iconPadding || 'inherit', ";inset-inline-start:auto}\n\n[dir=ltr] .sJGfW_bGBk.sJGfW_eyNH .sJGfW_dnnz{left:auto;right:").concat(theme.iconPadding || 'inherit', "}\n\n[dir=rtl] .sJGfW_bGBk.sJGfW_eyNH .sJGfW_dnnz{left:").concat(theme.iconPadding || 'inherit', ";right:auto}\n\n.sJGfW_bGBk[role=menuitemcheckbox],.sJGfW_bGBk[role=menuitemradio]{-webkit-padding-start:").concat(theme.labelPadding || 'inherit', ";padding-inline-start:").concat(theme.labelPadding || 'inherit', "}\n\n[dir=ltr] .sJGfW_bGBk[role=menuitemcheckbox],[dir=ltr] .sJGfW_bGBk[role=menuitemradio]{padding-left:").concat(theme.labelPadding || 'inherit', "}\n\n[dir=rtl] .sJGfW_bGBk[role=menuitemcheckbox],[dir=rtl] .sJGfW_bGBk[role=menuitemradio]{padding-right:").concat(theme.labelPadding || 'inherit', "}\n\n.sJGfW_bGBk[role=menuitemcheckbox] .sJGfW_dnnz,.sJGfW_bGBk[role=menuitemradio] .sJGfW_dnnz{inset-inline-end:auto;inset-inline-start:").concat(theme.iconPadding || 'inherit', "}\n\n[dir=ltr] .sJGfW_bGBk[role=menuitemcheckbox] .sJGfW_dnnz,[dir=ltr] .sJGfW_bGBk[role=menuitemradio] .sJGfW_dnnz{left:").concat(theme.iconPadding || 'inherit', ";right:auto}\n\n[dir=rtl] .sJGfW_bGBk[role=menuitemcheckbox] .sJGfW_dnnz,[dir=rtl] .sJGfW_bGBk[role=menuitemradio] .sJGfW_dnnz{left:auto;right:").concat(theme.iconPadding || 'inherit', "}\n\n.sJGfW_bGBk.sJGfW_cSen,.sJGfW_bGBk:active,.sJGfW_bGBk:focus,.sJGfW_bGBk:hover,.sJGfW_bGBk[aria-expanded=true]{background:").concat(theme.activeBackground || 'inherit', "}\n\n.sJGfW_bGBk.sJGfW_cSen .sJGfW_blJt,.sJGfW_bGBk:active .sJGfW_blJt,.sJGfW_bGBk:focus .sJGfW_blJt,.sJGfW_bGBk:hover .sJGfW_blJt,.sJGfW_bGBk[aria-expanded=true] .sJGfW_blJt{color:").concat(theme.activeLabelColor || 'inherit', "}\n\n.sJGfW_bGBk.sJGfW_cSen .sJGfW_dnnz,.sJGfW_bGBk:active .sJGfW_dnnz,.sJGfW_bGBk:focus .sJGfW_dnnz,.sJGfW_bGBk:hover .sJGfW_dnnz,.sJGfW_bGBk[aria-expanded=true] .sJGfW_dnnz{color:").concat(theme.activeIconColor || 'inherit', "}\n\n.sJGfW_bGBk::-moz-focus-inner{border:0;margin:0;padding:0}\n\n.sJGfW_bGBk[aria-disabled]{cursor:not-allowed;opacity:0.5;pointer-events:none}\n\n.sJGfW_blJt{color:").concat(theme.labelColor || 'inherit', "}\n\n.sJGfW_dnnz{align-items:center;color:").concat(theme.iconColor || 'inherit', ";display:flex;height:100%;position:absolute;top:0;width:1em}\n\na.sJGfW_bGBk,a.sJGfW_bGBk:active,a.sJGfW_bGBk:focus,a.sJGfW_bGBk:hover,a.sJGfW_bGBk:link,a.sJGfW_bGBk:visited{text-decoration:none}");
  },
  'root': 'sJGfW_bGBk',
  'flyout': 'sJGfW_eyNH',
  'icon': 'sJGfW_dnnz',
  'active': 'sJGfW_cSen',
  'label': 'sJGfW_blJt'
};

var _ref =
/*#__PURE__*/
_react.default.createElement(_IconCheck.default, null);

var _ref2 =
/*#__PURE__*/
_react.default.createElement(_IconArrowOpenEnd.default, null);

/**
---
parent: Menu
---
**/
var MenuItem = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _deprecated.default)('5.0.0', {
  active: true
}), _dec3 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MenuItem, _Component);

  function MenuItem(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MenuItem);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MenuItem).call(this));

    _this.handleClick = function (e) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled,
          value = _this$props.value;
      var selected = !_this.selected;

      if (disabled) {
        e.preventDefault();
        return;
      }

      if (typeof _this.props.selected === 'undefined') {
        _this.setState({
          selected: selected
        });
      }

      if (typeof onSelect === 'function') {
        e.persist();
        onSelect(e, value, selected, (0, _assertThisInitialized2.default)(_this));
      }

      if (typeof onClick === 'function') {
        onClick(e);
      }
    };

    _this.handleKeyDown = function (e) {
      var spaceKey = e.keyCode === _keycode.default.codes.space;
      var enterKey = e.keyCode === _keycode.default.codes.enter;

      if (spaceKey || enterKey) {
        e.preventDefault();
        e.stopPropagation();

        if (enterKey) {
          // handle space key on keyUp for FF
          (0, _findDOMNode.default)(_this._node).click(); // eslint-disable-line react/no-find-dom-node
        }
      }
    };

    _this.handleKeyUp = function (e) {
      var spaceKey = e.keyCode === _keycode.default.codes.space;
      var enterKey = e.keyCode === _keycode.default.codes.enter;

      if (spaceKey || enterKey) {
        e.preventDefault();
        e.stopPropagation();

        if (spaceKey) {
          (0, _findDOMNode.default)(_this._node).click(); // eslint-disable-line react/no-find-dom-node
        }
      }
    };

    _this.handleMouseOver = function (event) {
      _this.focus();

      if (typeof _this.props.onMouseOver === 'function') {
        _this.props.onMouseOver(event, (0, _assertThisInitialized2.default)(_this));
      }
    };

    if (typeof props.selected === 'undefined') {
      _this.state = {
        selected: props.defaultSelected
      };
    }

    _this.labelId = (0, _uid.default)('MenuItem__label');
    return _this;
  }

  (0, _createClass2.default)(MenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var context = (0, _MenuContextTypes.getMenuContext)(this.context);

      if (context && context.registerMenuItem) {
        context.registerMenuItem(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var context = (0, _MenuContextTypes.getMenuContext)(this.context);

      if (context && context.registerMenuItem) {
        context.removeMenuItem(this);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      (0, _findDOMNode.default)(this._node).focus(); // eslint-disable-line react/no-find-dom-node
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          type = _this$props2.type;
      return _react.default.createElement("span", null, (type === 'checkbox' || type === 'radio') && _react.default.createElement("span", {
        className: styles.icon
      }, this.selected && _ref), _react.default.createElement("span", {
        className: styles.label,
        id: this.labelId
      }, children), type === 'flyout' && _react.default.createElement("span", {
        className: styles.icon
      }, _ref2));
    }
  }, {
    key: "render",
    value: function render() {
      var _classes,
          _this2 = this;

      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          controls = _this$props3.controls,
          onKeyDown = _this$props3.onKeyDown,
          onKeyUp = _this$props3.onKeyUp,
          type = _this$props3.type,
          href = _this$props3.href;
      var props = (0, _passthroughProps.omitProps)(this.props, MenuItem.propTypes);
      var ElementType = this.elementType;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles.flyout, type === 'flyout'), _classes);
      return _react.default.createElement(ElementType // eslint-disable-line jsx-a11y/mouse-events-have-key-events
      , Object.assign({
        tabIndex: "-1" // note: tabIndex can be overridden by Menu or MenuItemGroup components

      }, props, {
        href: href,
        role: this.role,
        "aria-labelledby": this.labelId,
        "aria-disabled": disabled ? 'true' : null,
        "aria-controls": controls,
        "aria-checked": type === 'checkbox' || type === 'radio' ? this.selected ? 'true' : 'false' : null,
        onClick: this.handleClick,
        onKeyUp: (0, _createChainedFunction.default)(onKeyUp, this.handleKeyUp),
        onKeyDown: (0, _createChainedFunction.default)(onKeyDown, this.handleKeyDown),
        ref: function ref(c) {
          _this2._node = c;
        },
        className: (0, _classnames.default)(classes),
        onMouseOver: this.handleMouseOver
      }), this.renderContent());
    }
  }, {
    key: "elementType",
    get: function get() {
      return (0, _getElementType.default)(MenuItem, this.props);
    }
  }, {
    key: "role",
    get: function get() {
      switch (this.props.type) {
        case 'checkbox':
          return 'menuitemcheckbox';

        case 'radio':
          return 'menuitemradio';

        case 'flyout':
          return 'button';

        default:
          return 'menuitem';
      }
    }
  }, {
    key: "selected",
    get: function get() {
      return typeof this.props.selected === 'undefined' ? this.state.selected : this.props.selected;
    }
  }, {
    key: "focused",
    get: function get() {
      return (0, _isActiveElement.default)(this._node);
    }
  }]);
  MenuItem.displayName = "MenuItem";
  return MenuItem;
}(_react.Component), _class2.propTypes = {
  /* the menu item label */
  children: _propTypes.default.node.isRequired,

  /* whether to set the menu item state to selected or not on initial render */
  defaultSelected: _propTypes.default.bool,

  /**
  * whether the menu item is selected or not (must be accompanied by an `onSelect` prop)
  */
  selected: (0, _uiPropTypes.controllable)(_propTypes.default.bool, 'onSelect', 'defaultSelected'),

  /**
  * when used with the `selected` prop, the component will not control its own state
  */
  onSelect: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  onMouseOver: _propTypes.default.func,

  /**
  * the id of the element that the menu item will act upon
  */
  controls: _propTypes.default.string,
  disabled: _propTypes.default.bool,

  /**
  * the element type to render as (will default to `<a>` if href is provided)
  */
  as: _propTypes.default.elementType,
  // eslint-disable-line react/require-default-props
  type: _propTypes.default.oneOf(['button', 'checkbox', 'radio', 'flyout']),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  href: _propTypes.default.string
}, _class2.defaultProps = {
  type: 'button',
  disabled: false,
  onSelect: function onSelect(e, value, selected, item) {},
  defaultSelected: void 0,
  selected: void 0,
  onClick: void 0,
  onKeyDown: void 0,
  onKeyUp: void 0,
  onMouseOver: void 0,
  controls: void 0,
  value: void 0,
  href: void 0
}, _class2.contextTypes = _MenuContextTypes.MenuContextTypes, _temp)) || _class) || _class) || _class);
var _default = MenuItem;
exports.default = _default;